import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet } from '_zari/core'

import * as CompaniaCrud from 'services/compania.service'

import MainForm from './mainForm'

const CompaniaFichaPage = () => {
  const [companiaData, setCompaniaData] = React.useState(null)
  const __zariContext = React.useContext(ZariContext)

  React.useEffect(() => {
    CompaniaCrud.getCompania()
      .then(({ data }) => {
        setCompaniaData(data)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <>
      {companiaData && (
        <>
          <Portlet>
            <Portlet.Header title='CONFIGURACION COMPAÑIA' />
            <Portlet.Body>
              <MainForm dataCompania={companiaData} />
            </Portlet.Body>
          </Portlet>
        </>
      )}
    </>
  )
}

export default CompaniaFichaPage
